<template>
  <div
    class="common-box single-box"
    @click="companyClicked"
  >
    <div
      v-if="rowActions.length > 0"
      class="common-box-actions"
      @click.stop.prevent
    >
      <context-dropdown
        :min-width="240"
        :options="rowActions"
        :placement="'bottom-end'"
      />
    </div>
    <div class="common-box-details">
      <company-icon :company="company" />
      <p>
        <tooltip-too-long
          :length="16"
          :text="company.name"
        />
      </p>
    </div>
  </div>
</template>
<script>
import ContextDropdown from "../common/dropdown/ContextDropdown"
import CompanyIcon from "../common/CompanyIcon"

export default {
  components: {
    CompanyIcon,
    ContextDropdown
  },
  props: {
    company: {
      type: Object,
      required: true
    },
    rowActions: {
      type: Array,
      required: true
    }
  },
  emits: ["company-clicked"],
  data () {
    return {
      dropdownActive: false
    }
  },
  methods: {
    toggleDropdown () {
      this.dropdownActive = !this.dropdownActive
    },
    hideDropdown () {
      this.dropdownActive = false
    },
    companyClicked () {
      this.$emit("company-clicked", this.company)
    }
  }
}
</script>
